(() => {
	'use strict';

	//===========================
	// 汎用
	//===========================
	/** メディアクエリ SP⇆PCの切り替わり */
	const desktopQuery = window.matchMedia('(min-width: 769px)');
	/** メディアクエリ PCのレイアウトカラム数2⇆3の切り替わり */
	const columnChangeQuery = window.matchMedia('(min-width: 1001px)');

	/** htmlのスクロール禁止処理 */
	const disallowScroll = () => {
		document.documentElement.classList.add('is-fixed');
	};

	/** htmlのスクロール禁止解除 */
	const allowScroll = () => {
		document.documentElement.classList.remove('is-fixed');
	};

	/**
	 * ハンバーガーメニュー開く処理
	 * @param {HTMLElement} button
	 * @param {HTMLElement} menu
	 */
	const openMenu = (button, menu) => {
		disallowScroll();
		button.classList.add('is-open');
		menu.classList.add('is-open', 'is-animated');
	};

	/**
	 * ハンバーガーメニュー閉じる処理
	 * @param {HTMLElement} button
	 * @param {HTMLElement} menu
	 */
	const closeMenu = (button, menu) => {
		allowScroll();
		button.classList.remove('is-open');
		menu.classList.remove('is-open');
	};

	//===========================
	// ハンバーガーメニュー開閉
	//===========================
	const toggleHeaderMenu = () => {
		const dataPref = 'data-header_menu';
		const button = document.querySelector(`[${dataPref}-button]`);
		const menu = document.querySelector(`[${dataPref}-menu]`);
		const links = document.querySelectorAll(`[${dataPref}-link]`);

		// 開く処理
		button.addEventListener('click', () => {
			if (menu.classList.contains('is-open')) {
				closeMenu(button, menu);
			} else {
				openMenu(button, menu);
			}
		});

		// ページ内遷移時にメニューを閉じる
		links.forEach((link) => {
			const href = link.getAttribute('href');
			if (!href.startsWith('#')) return;

			// hrefが#から始まる時のみ
			link.addEventListener('click', () => {
				closeMenu(button, menu);
			});
		});
	};

	//===========================
	// TOPへ戻る
	//===========================
	const scrollToTop = () => {
		const button = document.querySelector('[data-page_top]');
		const showHeight = 200;
		window.addEventListener('scroll', () => {
			if (window.scrollY > showHeight) {
				button.classList.add('is-active');
			} else {
				button.classList.remove('is-active');
			}
		});
	};

	//===========================
	// おすすめ記事一覧
	//===========================
	const initRecommendSlider = () => {
		const dataPref = 'data-slider_recommend';
		const slider = document.querySelector(`[${dataPref}]`);
		const slides = document.querySelectorAll(`[${dataPref}-slide]`);

		if (slides.length < 2) {
			return;
		}

		const prevButton = document.querySelector(`[${dataPref}-prev]`);
		const nextButton = document.querySelector(`[${dataPref}-next]`);
		const pagination = document.querySelector(`[${dataPref}-pagination]`);

		const swiper = new Swiper(slider, {
			centeredSlides: true,
			loop: true,
			slidesPerView: 'auto',
			allowTouchMove: true,
			spaceBetween: 20,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			pagination: {
				el: pagination,
				bulletClass: 'recommend-slider__pagination-bullet',
				bulletActiveClass: 'is-active',
				clickable: true,
			},
		});
	};

	//===========================
	// 目次 開閉
	//===========================
	/**
	 * 目次 高さによってis-staticクラスを付け外し
	 * @param {HTMLElement} list
	 */
	const setTocStaticState = (list) => {
		if (!list) return;

		const listHeight = list.offsetHeight;
		const listScrollHeight = list.scrollHeight;

		// リストの中身の高さがmax-heightよりも小さい時
		if (listScrollHeight <= listHeight) {
			list.classList.add('is-static');
		} else {
			list.classList.remove('is-static');
		}
	};

	const expandToc = () => {
		const dataPref = 'data-toc';
		const buttonAttr = `${dataPref}-button`;
		const listAttr = `${dataPref}-list`;
		const list = document.querySelector(`[${listAttr}]`);
		if (!list) return;

		const button = document.querySelector(`[${buttonAttr}]`);

		// 初回判定
		setTocStaticState(list);

		// リストの高さ変化を監視
		let prevHeight = list.scrollHeight;
		const observer = new ResizeObserver(() => {
			if (list.classList.contains('is-open')) return;

			const currentHeight = list.scrollHeight;
			// 高さが変わらない場合は実行しない
			if (prevHeight === currentHeight) return;
			// 高さを更新
			prevHeight = currentHeight;
			setTocStaticState(list);
		});
		observer.observe(list);

		button.addEventListener('click', () => {
			let listScrollHeight = list.scrollHeight;

			if (list.classList.contains('is-open')) {
				list.classList.remove('is-open');
				button.textContent = 'もっと見る';

				// maxHeight='none'からtransitionを効かせるための対応
				list.style.maxHeight = listScrollHeight + 'px';
				setTimeout(() => {
					list.style.maxHeight = '';
				});
			} else {
				list.classList.add('is-open');
				list.style.maxHeight = listScrollHeight + 'px';
				button.textContent = 'とじる';

				// 展開後は全て表示(リサイズで高さが変わる場合の対応)
				setTimeout(() => {
					list.style.maxHeight = 'none';
				}, 500);
			}
		});
	};

	toggleHeaderMenu();
	scrollToTop();
	initRecommendSlider();
	expandToc();

	// ＊＊＊＊ リサイズ時 ＊＊＊＊
	// ヘッダーメニューのアニメーション用クラス制御
	const checkHeaderMenu = (e) => {
		const menu = document.querySelector('[data-header_menu-menu]');
		const isAnimated = menu.classList.contains('is-animated');
		const isMenuOpen = menu.classList.contains('is-open');

		// メニューが開いている時のスクロール制御
		if (isMenuOpen) {
			// PCになった時
			if (e.matches) {
				allowScroll();
				return;
			}

			disallowScroll();
			return;
		}

		// is-animated が無ければ終了
		if (!isAnimated) return;

		// PCになった時
		if (e.matches) {
			// PC→SP切り替わり時の不要なアニメーションを防ぐ
			menu.classList.remove('is-animated');
		}
	};;

	// 目次 高さの変化によるトグルの無効化制御
	const checkTocHeight = () => {
		document.querySelectorAll(`[data-toc-list]`).forEach((list) => {
			if (!list) return;
			if (list.classList.contains('is-open')) return;

			setTocStaticState(list);
		});
	};

	desktopQuery.addEventListener('change', checkHeaderMenu);
	desktopQuery.addEventListener('change', checkTocHeight);
	columnChangeQuery.addEventListener('change', checkTocHeight);
})();
